<ng-container *ngIf="templateData$ | glxyAsyncStatus | async as result">
  <ng-container [ngSwitch]="result.status">
    <ng-container *ngSwitchCase="'loading'">
      <glxy-page>
        <glxy-page-toolbar>
          <glxy-page-title>
            <button mat-icon-button (click)="closePage()" color="primary">
              <mat-icon>arrow_back</mat-icon>
            </button>
            {{ 'EMAIL_LIBRARY.EDITOR.TITLE' | translate }}
          </glxy-page-title>
        </glxy-page-toolbar>

        <glxy-loading-spinner [fullHeight]="true" />
      </glxy-page>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <glxy-page>
        <glxy-page-toolbar>
          <glxy-page-title>
            <button mat-icon-button (click)="closePage()" color="primary">
              <mat-icon>arrow_back</mat-icon>
            </button>
            {{ 'EMAIL_LIBRARY.EDITOR.TITLE' | translate }}
          </glxy-page-title>
        </glxy-page-toolbar>

        <p>{{ 'EMAIL_LIBRARY.EDITOR.ERROR_LOADING_TEMPLATE' | translate }}</p>
      </glxy-page>
    </ng-container>

    <ng-container *ngSwitchCase="'loaded'">
      <glxy-page [pagePadding]="false">
        <glxy-page-toolbar>
          <glxy-page-title>
            <button mat-icon-button (click)="closePage()" color="primary">
              <mat-icon>arrow_back</mat-icon>
            </button>
            {{ 'EMAIL_LIBRARY.EDITOR.TITLE' | translate }}
          </glxy-page-title>
          <glxy-page-actions>
            <button mat-raised-button color="primary" (click)="saveAndClose()">
              {{ 'EMAIL_LIBRARY.EDITOR.SAVE_AND_CLOSE' | translate }}
            </button>
            <!--      TODO: Implement preview email functionality-->
            <!--      <button mat-button [matMenuTriggerFor]="actionsMenu">-->
            <!--        <mat-icon>more_vert</mat-icon>-->
            <!--      </button>-->
            <!--      <mat-menu #actionsMenu="matMenu">-->
            <!--        <button mat-menu-item>{{'EMAIL_LIBRARY.EDITOR.SEND_PREVIEW' | translate}}</button>-->
            <!--      </mat-menu>-->
          </glxy-page-actions>
        </glxy-page-toolbar>

        <email-builder
          [emailContent]="result.value"
          (emailContentChanged)="stageDataForSaving($event)"
          (emailRenderUpdated)="stageRawHtmlForSaving($event)"
          (htmlRendering)="setHtmlRendering($event)"
          [placeholderLogoUrl]="placeholderLogo$ | async"
          [dynamicComponents]="dynamicComponents"
          [advancedSections]="advancedSections"
          [previewHydrationParams]="previewHydrationData$ | async"
        ></email-builder>
      </glxy-page>
    </ng-container>
  </ng-container>
</ng-container>
